import { render, staticRenderFns } from "./zlbProposal.vue?vue&type=template&id=53f44030&"
import script from "./zlbProposal.vue?vue&type=script&lang=js&"
export * from "./zlbProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports